// src/App.jsx
import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'sonner'
import Layout from './components/layout/Layout'
import Home from './pages/public/Home'
import Services from './pages/public/Services'
import AboutUs from './pages/public/AboutUs'
import ContactUs from './pages/public/ContactUs'
import Feedback from './pages/public/Feedback'
import FAQ from './pages/public/FAQ'
import TermsOfService from './pages/public/TermsOfService'
import PrivacyPolicy from './pages/public/PrivacyPolicy'
import APK from './pages/public/APK'

function App() {
  return (
    <div className="App">
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/download" element={<APK />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" richColors />
    </div>
  )
}

export default App